import React from "react";
import { Toaster as SonnerToaster } from "sonner";

export const DEFAULT_TOAST_POSITION = "bottom-right";

export const Toaster = () => (
    <SonnerToaster
        position={DEFAULT_TOAST_POSITION}
        style={
            {
                "--width": "400px",
            } as React.CSSProperties
        }
    />
);
